<div class="non-residency-offline">
  <div class="box">
    <p class="stacy"><img src="../../../../../../assets/img/avatar-stacy2.png" alt="stacy"></p>
    <h4>Good job!</h4>
    <p>
      You can proceed to specific state questions.
    </p>
    <button (click)="submit()" class="btn btn-primary">{{ 'GeneralAdditional.Next' | translate }}</button>
  </div>
</div>